import { render, staticRenderFns } from "./replacementPerformanceProductionYearPieChart.vue?vue&type=template&id=4289c7e6&scoped=true"
import script from "./replacementPerformanceProductionYearPieChart.vue?vue&type=script&lang=js"
export * from "./replacementPerformanceProductionYearPieChart.vue?vue&type=script&lang=js"
import style0 from "./replacementPerformanceProductionYearPieChart.vue?vue&type=style&index=0&id=4289c7e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4289c7e6",
  null
  
)

export default component.exports